/**
 * Handoff / watchers / mentions contracts (T-021) — docs/10-design/04 §6 · tasks/W2-CONTRACTS.md §5
 * `Ticket` อ้างจาก index ผ่าน z.lazy (index export ไฟล์นี้ — กัน circular TDZ)
 */
import { z } from "zod";
import { Ticket } from "./index.ts";

export const HandoffMode = z.enum(["transfer", "child"]);
export type HandoffMode = z.infer<typeof HandoffMode>;

export const HandoffTo = z
	.object({
		department_id: z.uuid().optional(),
		team_id: z.uuid().optional(),
		user_id: z.uuid().optional(),
	})
	.refine((v) => v.department_id !== undefined || v.team_id !== undefined || v.user_id !== undefined, {
		message: "ต้องระบุปลายทางอย่างน้อยหนึ่งอย่าง (department_id/team_id/user_id)",
		path: ["to"],
	});
export type HandoffTo = z.infer<typeof HandoffTo>;

export const Handoff = z.object({
	mode: HandoffMode,
	to: HandoffTo,
	note: z.string().max(5000).optional(),
	requested_action: z.string().max(500).optional(),
	due_at: z.iso.datetime().optional(),
	expected_version: z.number().int(),
});
export type Handoff = z.infer<typeof Handoff>;

/** transfer → ตอบ Ticket; child → ตอบ HandoffResult (child != null) — W2-CONTRACTS §5 */
export const HandoffResult = z.object({
	parent: z.lazy(() => Ticket),
	child: z.lazy(() => Ticket.nullable()),
});
export type HandoffResult = z.infer<typeof HandoffResult>;

export const ReturnTicket = z.object({
	note: z.string().max(5000).optional(),
	expected_version: z.number().int(),
});
export type ReturnTicket = z.infer<typeof ReturnTicket>;

export const WatcherInput = z
	.object({
		user_id: z.uuid().optional(),
		team_id: z.uuid().optional(),
	})
	.refine((v) => (v.user_id !== undefined ? 1 : 0) + (v.team_id !== undefined ? 1 : 0) === 1, {
		message: "ต้องระบุ user_id หรือ team_id อย่างใดอย่างหนึ่ง",
		path: [],
	});
export type WatcherInput = z.infer<typeof WatcherInput>;

/** display: user = display_name, team = code — R4 */
export const Watcher = z.object({
	principal_type: z.enum(["user", "team"]),
	principal_id: z.uuid(),
	display: z.string(),
	added_at: z.iso.datetime(),
});
export type Watcher = z.infer<typeof Watcher>;
